import {ISpecificSafezoneObject} from "./safezone-object-factory.service.interface";
import {
  CHANNEL,
  CLOSE_SAFEZONE_SOURCE_VALUES,
  IMiniSafezoneHandler,
  OPEN_SAFEZONE_SOURCE_VALUES,
  SAFEZONE_CONTAINERS_ID,
  SAFEZONE_EVENTS
} from "./safezone.service.interface";
// import {reaction} from "mobx";
import {Check} from "@sparkware/app-utils";
// import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import SafezoneHandlerBase from "./safezone-handler-base";

export class MiniSafezoneHandler extends SafezoneHandlerBase implements IMiniSafezoneHandler{

  protected _category:string = SAFEZONE_EVENTS.CATEGORY_MINI;
  protected _openEventName:string = SAFEZONE_EVENTS.MINI_OPEN;
  protected _readyEventName:string = SAFEZONE_EVENTS.MINI_READY;
  protected _closeEventName:string;
  protected _channel:CHANNEL = CHANNEL.MINI;
  protected _containerId: SAFEZONE_CONTAINERS_ID = SAFEZONE_CONTAINERS_ID.MINI_SAFEZONE_CONTAINER_ID;

  // constructor(services: IServiceFactoryExtended){
  //   super(services);
  //   this._subscribeToUserMenuOpenReaction();
  // }

  init(safezoneObj:ISpecificSafezoneObject):void{
    super.init(safezoneObj);
    if(this._services.userMenu.isOpen){
      this._renderSafezone(OPEN_SAFEZONE_SOURCE_VALUES.USER_AREA);
    }
  }

  private _userMenuOpenReaction = null;
  // private _subscribeToUserMenuOpenReaction():void {
  //   this._userMenuOpenReaction = reaction(() => {
  //     return {
  //       userMenuIsOpen: this._services.userMenu.isOpen,
  //       isMobile: this._services.device.isMobile
  //     }
  //   }, (data) => {
  //     if(data.userMenuIsOpen) {
  //       this._checkAndRenderMiniSafezone();
  //     } else {
  //       this._closeEventName = SAFEZONE_EVENTS.MINI_CLOSE_EXTERNAL;
  //       this._closeSafezone(CLOSE_SAFEZONE_SOURCE_VALUES.CLIENT);
  //     }
  //   });
  // }


  private _unsubscribeFromUserMenuOpenReaction(): void{
    if(this._userMenuOpenReaction){
      this._userMenuOpenReaction();
      this._userMenuOpenReaction = null;
    }
  }

  public closeMiniSafezone():void{
    this._unsubscribeFromUserMenuOpenReaction();
    try {
      this._services.userMenu.closeMenu();
      this._closeEventName = SAFEZONE_EVENTS.MINI_CLOSE_INTERNAL;
      this._closeSafezone(CLOSE_SAFEZONE_SOURCE_VALUES.MINI_SZ);
    } finally {
      // this._subscribeToUserMenuOpenReaction();
    }
  }

  private async _checkAndRenderMiniSafezone():Promise<void>{
    if(Check.isNullOrUndefined(this._safezoneObject)){
      await this._services.safezone.reconnectToSafezone();
    }
    this._renderSafezone(OPEN_SAFEZONE_SOURCE_VALUES.USER_AREA);
  }

  public resetOnLogout(): void {
    super.resetOnLogout();
    this._unsubscribeFromUserMenuOpenReaction();
  }

  public get correlationID():string{
    return this._correlationId;
  }
}